<template>
  <!--For MCQ OR ORDERING-->
  <div>
    <div class="up-input-group">
      <up-select
        v-if="question_type == 'MCQ'"
        v-model="mcq.type"
        label="Options Type"
        size="md"
        labelIcon="mdi mdi-alpha-t-box-outline"
      >
        <option value="S">Single Correct</option>
        <option value="M">Multiple Correct</option>
      </up-select>
      <up-select
        v-if="question_type == 'MCQ'"
        v-model="mcq.has_custom_layout"
        label="Has Custom Layout"
        labelIcon="mdi mdi-alpha-t-box-outline"
      >
        <option :value="true">Yes</option>
        <option :value="false">No</option>
      </up-select>
      <up-numberinput
        v-if="question_type == 'MCQ'"
        ref="option_buttons_each_row"
        v-model="mcq.option_buttons_each_row"
        label="Options in a row"
        labelIcon="mdi mdi-alpha-s-box-outline"
      ></up-numberinput>
      <up-select
        v-model="mcq.allow_reading_options"
        label="Allow Reading Options"
        labelIcon="mdi mdi-alpha-t-box-outline"
      >
        <option :value="true">Yes</option>
        <option :value="false">No</option>
      </up-select>
      <b-button
        @click="addNewOption()"
        type="is-success"
        size="is-small"
        icon-left="plus"
      ></b-button>
    </div>

    <b-collapse
      class="card"
      animation="slide"
      v-for="(option_layer, op_index) in mcq.options"
      :key="`OPTION_${op_index}`"
      :open="isOptionOpen == op_index"
      @open="isOptionOpen = op_index"
    >
      <template #trigger="props">
        <div class="card-header" role="button">
          <p class="card-header-title">{{ `Option ${op_index + 1}` }}</p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="buttons">
              <b-button
                size="is-small"
                type="is-danger"
                @click="deleteOption(op_index)"
                >Remove</b-button
              >
              <b-button
                size="is-small"
                type="is-info"
                @click="copyOption(op_index)"
                >Copy</b-button
              >
            </div>
          </div>
          <div class="column is-6">
            <p class="title is-5 mb-0">General</p>
            <div class="up-input-group">
              <!-- Input Type Toggle -->
              <up-select
                v-model="option_layer.use_fraction_input"
                label="Input Type"
                labelIcon="mdi mdi-format-text"
              >
                <option :value="false">Text</option>
                <option :value="true">Fraction</option>
              </up-select>

              <!-- Regular Text Input -->
              <up-textinput
                v-if="!option_layer.use_fraction_input"
                v-model="option_layer.name"
                label="Option"
                size="lg"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-textinput>

              <!-- Fraction Input -->
              <fraction-input
                v-if="option_layer.use_fraction_input"
                v-model="option_layer.name"
                label="Option (Fraction)"
                size="lg"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></fraction-input>

              <up-select
                v-model="option_layer.is_hide_label"
                label="Hide Label"
                labelIcon="mdi mdi-alpha-t-box-outline"
              >
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </up-select>

              <up-select
                v-model="option_layer.option_type"
                label="Option Design"
                labelIcon="mdi mdi-alpha-t-box-outline"
              >
                <option value="D">Default</option>
                <option value="S">Simple</option>
              </up-select>

              <up-numberinput
                v-model="option_layer.order"
                label="Order"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-numberinput>

              <up-numberinput
                v-model="option_layer.custom_width"
                label="Custom Width"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-numberinput>
            </div>
          </div>

          <!--Styles-->
          <div class="column is-6">
            <p class="title is-5 mb-0">Styles</p>
            <div class="up-input-group">
              <up-numberinput
                v-if="option_layer.option_type == 'S'"
                v-model="option_layer.styles.border_width"
                label="Border Width"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-numberinput>

              <up-textinput
                v-if="option_layer.option_type == 'S'"
                v-model="option_layer.styles.border_color"
                label="Border Color"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-textinput>

              <up-textinput
                v-if="option_layer.option_type == 'S'"
                v-model="option_layer.styles.font_color"
                label="Font Color"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-textinput>

              <up-numberinput
                v-model="option_layer.styles.font_size"
                label="Font Size"
                labelIcon="mdi mdi-alpha-s-box-outline"
              ></up-numberinput>

              <up-select
                v-model="option_layer.styles.text_align"
                label="Text Align"
                labelIcon="mdi mdi-alpha-t-box-outline"
              >
                <option value="left">Left</option>
                <option value="right">Right</option>
                <option value="center">Center</option>
              </up-select>
            </div>
          </div>
        </div>

        <!--Additional Options-->
        <b-collapse
          class="card"
          animation="slide"
          v-for="(mcq_part_collapse, index) of mcq_part_collapses"
          :key="`MCQ_OPTION_${op_index}_${index}`"
          :open="optionPartCollapsesIsOpen == index"
          @open="optionPartCollapsesIsOpen = index"
        >
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">
                {{ mcq_part_collapse.title }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="content">
              <!--For Clipart Layers-->
              <set-clipart-layer
                v-if="mcq_part_collapse.type == 'CLIPART_LAYER'"
                :key="`OPTION_${op_index}_CLIP_LAYER`"
                :show_track_count="false"
                v-model="option_layer.layers"
              ></set-clipart-layer>

              <!--Adding tables-->
              <set-tables
                v-if="mcq_part_collapse.type == 'TABLES'"
                :key="`OPTION_${op_index}_TABLES`"
                v-model="option_layer.tables"
              ></set-tables>

              <!--Set Clock-->
              <set-clock
                v-if="mcq_part_collapse.type == 'CLOCK'"
                :key="`OPTION_${op_index}_CLOCK`"
                v-model="option_layer.clock"
              ></set-clock>

              <!--Set Protractor-->
              <set-protractor
                v-if="mcq_part_collapse.type == 'PROTRACTOR'"
                :key="`OPTION_${op_index}_PROTRACTOR`"
                v-model="option_layer.protractor"
              ></set-protractor>

              <!--Set Custom Layout For new questions past 11th Aug, 2021-->
              <set-custom-layout
                v-if="mcq_part_collapse.type == 'CUSTOM_LAYOUT'"
                :key="`OPTION_${op_index}_CL`"
                v-model="option_layer.custom_layout"
                :question_type="question_type"
              ></set-custom-layout>

              <!--Set Bar Chart-->
              <set-bar-chart
                v-if="mcq_part_collapse.type == 'BARCHART'"
                :key="`OPTION_${op_index}_BARCHART`"
                v-model="option_layer.bar_chart"
              ></set-bar-chart>

              <!--Set Line Chart-->
              <set-line-chart
                v-if="mcq_part_collapse.type == 'LINECHART'"
                :key="`OPTION_${op_index}_LINECHART`"
                v-model="option_layer.line_chart"
              ></set-line-chart>

              <!--Set Thermometer-->
              <set-thermometer
                v-if="mcq_part_collapse.type == 'THERMOMETER'"
                :key="`OPTION_${op_index}_THERMOMETER`"
                v-model="option_layer.thermometer"
              ></set-thermometer>

              <!--Set Number Line-->
              <set-number-line
                v-if="mcq_part_collapse.type == 'NUMBER_LINE'"
                :key="`OPTION_${op_index}_NUMBERLINE`"
                v-model="option_layer.number_line"
              ></set-number-line>

              <!-- Set Shapes -->
              <set-shapes
                v-if="mcq_part_collapse.type == 'SHAPES'"
                :key="`OPTION_${op_index}_SHAPES`"
                v-model="option_layer.shapes"
              ></set-shapes>
            </div>
          </div>
        </b-collapse>
      </div>
    </b-collapse>

    <!--MCQ Answer--->
    <b-field v-if="question_type == 'MCQ'" label="Correct Answer">
      <b-select
        ref="options"
        required
        multiple
        v-model="mcq.answer"
        placeholder="Answer"
        icon="filter-variant"
        expanded
      >
        <option
          v-for="(option, j) in mcq.options"
          :key="`OPTION_SLT_${j}`"
          :value="j"
        >
          {{
            mcq.options[j].name.length ? mcq.options[j].name : `Option ${j + 1}`
          }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>
<script>
// Utils
import {
  defaultMCQValue,
  defaultOrderingValue,
  defaultMCQOptionValue,
} from "./utils";
// Components
import SetClipartLayer from "@/components/Question/SetClipartLayer";
import SetTables from "@/components/Question/SetTables";
import SetClock from "@/components/Question/Clock/SetClock";
import SetProtractor from "@/components/Question/Protractor/SetProtractor";
import SetCustomLayout from "@/components/Question/CustomLayout/SetCustomLayout";
import SetBarChart from "@/components/Question/Charts/SetBarChart";
import SetLineChart from "@/components/Question/Charts/SetLineChart";
import SetThermometer from "@/components/Question/Thermometer/SetThermometer";
import SetNumberLine from "@/components/Question/NumberLine/SetNumberLine";
import SetShapes from "@/components/Question/Shapes/SetShapes";

// UI Components
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSelect from "@/components/UI/Inputs/UpSelect";
import FractionInput from "@/components/UI/Inputs/FractionInput";

export default {
  name: "set-mcq",
  components: {
    SetClipartLayer,
    SetTables,
    SetClock,
    SetProtractor,
    SetCustomLayout,
    SetBarChart,
    SetLineChart,
    SetThermometer,
    SetNumberLine,
    UpTextinput,
    UpNumberinput,
    UpSelect,
    FractionInput,
    SetShapes,
  },
  props: {
    question_type: {
      type: String, // Can be MCQ or ORDERING
      required: true,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {
      isOptionOpen: 0,
      optionPartCollapsesIsOpen: null,
      mcq: this.value
        ? this.value
        : this.question_type == "MCQ"
        ? defaultMCQValue()
        : defaultOrderingValue(),
      mcq_part_collapses: [
        { title: "Cliparts", type: "CLIPART_LAYER" },
        { title: "Tables", type: "TABLES" },
        { title: "Clock", type: "CLOCK" },
        { title: "Protractor", type: "PROTRACTOR" },
        { title: "Custom Layout", type: "CUSTOM_LAYOUT" },
        { title: "Bar Chart", type: "BARCHART" },
        { title: "Line Chart", type: "LINECHART" },
        { title: "Thermometer", type: "THERMOMETER" },
        { title: "Number Line", type: "NUMBER_LINE" },
        { title: "Shapes", type: "SHAPES" },
      ],
    };
  },
  methods: {
    addNewOption() {
      this.mcq.options.push(defaultMCQOptionValue(this.mcq.options.length));
      //Opening the latest option
      this.isOptionOpen = this.mcq.options.length - 1;

      //Showing message to user
      this.$buefy.toast.open({
        message: "New Option Added",
        type: "is-success",
      });
    },
    deleteOption(index) {
      this.mcq.options.splice(index, 1);
    },
    copyOption(index) {
      this.mcq.options.push(
        JSON.parse(JSON.stringify(this.mcq.options[index]))
      );
    },
  },
  watch: {
    value: {
      handler: function (new_val) {
        this.mcq = new_val;
      },
      deep: true,
    },
    mcq: {
      handler: function (new_val) {
        console.log("DDDDDD", new_val)
        this.$emit("input", new_val);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
</style>